import React from "react";
import { useParams } from "react-router";
import { useGetWorkflowQuery } from "../../../generated/graphql";
import { setTitle } from "../../../utils/title";
import { WorkflowContent } from "../../Workflows/Workflow";
import { Loading } from "../__styles__/Guest";
import AccessDeniedPage, { ACCESS_DENIED_RESOURCE } from "../AccessDeniedPage";
import Layout from "../Layout";
import { accountTitle } from "../utils";

export const Workflow = () => {
  const { workflowId } = useParams<{
    workflowId: string;
  }>();

  const { data, loading } = useGetWorkflowQuery({
    variables: { workflowId },
    fetchPolicy: "network-only",
  });

  const title = data?.workflow?.workflowDefinition.name ?? "Loading...";
  setTitle(`${title} | ${accountTitle()}`);

  if (loading) {
    return <Loading />;
  }

  if (!data?.workflow) {
    return <AccessDeniedPage resource={ACCESS_DENIED_RESOURCE.WORKFLOW} />;
  }

  const { workflow } = data;

  return (
    <Layout hasGutters={true}>
      <WorkflowContent workflow={workflow} />
    </Layout>
  );
};
